/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-23 14:49:19
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import { store } from 'src/stores/store';

class PriceHelper {
  /**
   * Init values from first loading
   *
   * @param  {object} filterOption  filter option value
   * @param  {object} initialValue default values
   *
   * @return {object}               init values
   */
  static initialValues = (filterOption: Object, initialValue: Object) => {
    const {
      displayType,
      sliderDelimiter,
      sliderRange = 4,
      sliderStep = 1,
      hideTextBoxes = false,

      manualValues,
      excludePriceFromValue,
      shortenPipsRange
    } = filterOption;

    let priceList = [{ to: 10 }];
    if (displayType === 'list') {
      if (!_.isEmpty(manualValues)) {
        priceList = manualValues.map(item => {
          //process manual value
          let arr = item.split(':');
          return { from: arr[0], to: arr[1] };
        });
        // Remove last item
        priceList.pop();
      }
    }

    const result = {
      ...initialValue,
      priceDisplayType: displayType,
      priceSliderRange: sliderRange,
      priceSliderStep: sliderStep,
      priceSliderDelimiter: sliderDelimiter,
      priceHideTextBoxes: hideTextBoxes,
      priceList,
      priceExcludePriceFromValue: excludePriceFromValue,
      priceShortenPipsRange: shortenPipsRange
    };

    return result;
  };

  /**
   * Build filter option data based on input values
   *
   * @param  {object} filterOption    input values
   * @param  {object} defaultValues   default values
   *
   * @return {object}                 filter option values
   */
  static buildFilterOptionValues = (filterOption: Object, defaultValues: Object) => {
    const {
      priceDisplayType,
      priceSliderRange,
      priceSliderStep,
      priceSliderDelimiter,
      priceHideTextBoxes,
      priceList,
      priceExcludePriceFromValue,
      priceShortenPipsRange
    } = filterOption;

    let manualValues = null;
    if (priceDisplayType === 'list') {
      if (!_.isEmpty(priceList)) {
        manualValues = priceList.map(item => {
          const { from, to } = item;
          return `${from ? from : ''}:${to}`;
        });
        manualValues.push(`${priceList[priceList.length - 1].to}:`);
      }
    }

    // Add currency value for preview
    const currentState = store.getState();
    let moneyFormatValue = _.get(currentState, 'oauth.tenantApp.externalInfo.money_format', '');

    const result = {
      ...defaultValues,
      displayType: priceDisplayType,
      sliderRange: priceSliderRange,
      sliderStep: priceSliderStep,
      sliderDelimiter: priceSliderDelimiter,
      hideTextBoxes: priceHideTextBoxes,
      manualValues,
      excludePriceFromValue: priceExcludePriceFromValue,
      shortenPipsRange: priceShortenPipsRange,
      moneyFormatValue
    };

    return result;
  };

  /**
   * Fake product data for price
   *
   * @param  {object} filterOption
   * @return {array}              list of product count
   */
  static fakeProductValues = (filterOption: Object) => {
    const { displayType } = filterOption;
    let values;
    if (displayType === 'list') {
      values = _.map(filterOption.manualValues, item => {
        const arr = item.split(':');
        const from = arr[0],
          to = arr[1];
        const key = `${from ? from : '*'}-${to ? to : '*'}`;

        return {
          doc_count: Math.floor(Math.random() * 100) + 1,
          key,
          from: from ? from : undefined,
          to: to ? to : undefined
        };
      });
    } else {
      values = {
        max: 1000,
        min: 0
      };
    }

    return values;
  };
}

export default PriceHelper;
